import { type SearchRequest } from '@searchkit/api';

import { createResponseFactory } from '~/search-domain/pipelines/positive-ev/response-factory';
import { type ValueBetSearchResponseBody } from '~/search-domain/pipelines/positive-ev/types';
import { type SearchDomainContext, type SearchPipelineEnrichments } from '~/search-domain/types';
import { createElasticSearchContext, createResponseFactoryContext } from '~/search-domain/utils';

export async function transformPositiveEvResponse(
  context: SearchDomainContext,
  {
    enrichments,
    searchRequest,
    searchResponse,
  }: {
    enrichments?: SearchPipelineEnrichments;
    searchRequest: SearchRequest;
    searchResponse: ValueBetSearchResponseBody;
  },
) {
  const hitsPerPage = searchRequest?.request?.params?.hitsPerPage ?? 10;
  const page = searchRequest?.request?.params?.page ?? 0;
  const from = page * hitsPerPage;

  const elasticContext = createElasticSearchContext(context);

  return createResponseFactory.call(
    createResponseFactoryContext(context),
    elasticContext,
    searchResponse,
    from,
    hitsPerPage,
    enrichments?.bookmakerCountsByBetId,
  );
}
